// extracted by mini-css-extract-plugin
export default {"head":"TablePropertiesHead_head__5uDiZ","label":"TablePropertiesHead_label__ndtld"};